<template>
  <div class="Login-container">
    <div class="allClass">
      <div class="titleClass"><b>欢迎登录人工智能系统</b></div>

      <el-form :rules="ruleList" :model="user" ref="userForm"><!--用来校验表单-->

        <el-form-item prop="name"><!--必须el-form-item prop="xxx"才能生效-->
          <el-input size="medium" class="inputOneClass" prefix-icon="el-icon-message" placeholder="请输入邮箱账号"
                    v-model="user.name" autocomplete="new-password"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input size="medium" class="inputOneClass" prefix-icon="el-icon-lock" v-model="user.password"
                    placeholder="请输入密码"
                    autocomplete="new-password" show-password></el-input>
        </el-form-item>

        <el-form-item prop="validCode">
          <div style="display: flex">
            <el-input prefix-icon="el-icon-finished" v-model="user.validCode" style="width: 60%;"
                      class="inputOneClass" size="medium"
                      placeholder="请输入验证码"></el-input>
            <ValidCode @input="createValidCode" style="margin-left: 15px;margin-top: 5px;"/>
          </div>
        </el-form-item>

        <div class="buttonClass">
          <el-button type="primary" size="medium" @click="loginClick">登录
          </el-button>
          <el-button type="warning" size="medium" @click="$router.push('/register')">注册
          </el-button>
        </div>

        <!-- 重置密码-->
        <div class="buttonClass">
          <a href="#" @click="$router.push('/password')" style="text-decoration: none;color: #409EFF;font-size: 16px;">重置密码</a>
        </div>

        <!-- 手机版入口 -->
        <div class="buttonClass">
          <a href="#" @click="$router.push('/login_h5')" style="text-decoration: none;color: #909399;font-size: 14px;">手机版入口</a>
        </div>

      </el-form>

    </div>
  </div>
</template>

<script>
import {setRoutes} from '@/js_router/router.js'
import ValidCode from "@/vue_views/components/ValidCode";

export default {
  name: "Login",
  components: {
    ValidCode: ValidCode
  },
  data() {
    return {
      user: {},
      validCode: "",
      ruleList: { // 在return的第一级别写
        name: [
          {required: true, message: '请输入用户名即您的邮箱', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        validCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 3, max: 4, message: '长度在3-4个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 接受4为验证码
    createValidCode(data) {
      this.validCode = data
    },
    /*点击登录*/
    loginClick() {
      this.$refs["userForm"].validate(valid => {
        if (valid) { // 表单校验合法
          if (!this.user.validCode) {
            this.$message.error("请填写验证码")
            return false
          }
          if (this.user.validCode.toLowerCase() !== this.validCode.toLowerCase()) {
            this.$message.error("验证码错误")
            return false
          }
          this.$http.post("/big/login", this.user).then(res => {
            // console.log(res.data)
            if (res.data.code === "200") {
              localStorage.setItem("user", JSON.stringify(res.data.object)) // 存储用户信息到浏览器
              localStorage.setItem("menuList", JSON.stringify(res.data.object.menuList)) // 存储菜单信息
              setRoutes()// 动态设置当前用户路由
              if (res.data.object.role === "white") {
                this.$router.push("/main") // 跳转前台首页
              } else { // 跳到后台首页
                this.$router.push("/home")
                this.$message.success("登录成功，欢迎您")
              }
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.Login-container {
  height: 100vh;
  background-image: linear-gradient(to bottom right, deepskyblue, darkcyan);
  overflow: hidden;
}

.allClass {
  margin: 200px auto;
  background-color: #ffffff;
  width: 350px;
  height: 390px;
  padding: 20px;
  border-radius: 10px;
}

.titleClass {
  margin: 20px 0;
  text-align: center;
  font-size: 24px;
}

.inputOneClass {
  margin: 10px 0;
}

.buttonClass {
  margin: 10px 0;
  text-align: right;
}
</style>
